export const USER_ROLES = {
  ADMIN: 1,
  SCHEDULAR: 2,
  FSR: 3,
  SUPERADMIN: 6,
};

export const ENROLLMENTS_SCHEDULE_TYPES = {
  OPEN: 1,
  SCHEDULED: 2,
  SELF_SERVICE: 3,
  SCHEDULED_VIRTUAL: 4,
  DONE: 5,
};

export const APPOINTMENT_STATUS_TYPES = {
  SCHEDULED: 1,
  CONFIRMED: 2,
  CANCELLED: 3,
  NO_SHOW: 4,
  FINISHED: 5,
};

export const SCHEDULE_EVENT_TYPES = {
  APPOINTMENT_EVENT: 1,
  TRAVEL_EVENT: 2
};

export const ENROLLMENT_STATUS_TYPES = {
  CONFIGURATION_NEEDED: 1,
  READY: 2,
  IN_PROCESS: 3,
  POST_ENROLLMENT: 4,
  SENT_SELF_SERVICE: 5,
  PENDING: 6,
  COMPLETED: 7,  
  PARTICIPANT_COMPLETED: 8,  
};

export const SIGNING_TYPE = {
  1: 'Email Link for Signature Selected',
  2: 'Embedded Signature Selected'
}; 